import {initMainHeader, addBLazyContainer} from '../js/src/header-init';
import {addThirdPartyLoad, initFreshChatScript, onPriceMatchFreshChatClick} from "../js/src/utils";
import {init as shopInit} from "../js/pages/shop-main";
import {getQuoteFormInit} from "../js/src/get-quote-form";
import '../scss/pages/show-server.scss';

initFreshChatScript();
global.priceMatch = onPriceMatchFreshChatClick;

initMainHeader();
shopInit();
addThirdPartyLoad(() => {
    getQuoteFormInit()
    addBLazyContainer('.lazy-container');
});
